export const legacyUrl = import.meta.env.VITE_LEGACY_URL
export const isDebug = import.meta.env.VITE_IS_DEBUG === 'true'
export const isMock = import.meta.env.MODE === 'mock'
